<div>
  @if (mandatory === true) {
    <div style="color: red">(*)</div>
  }
  <div>{{ caption }}</div>
</div>
<div>
  <dx-text-area [(value)]="value" [autoResizeEnabled]="true" [minHeight]="15" [maxHeight]="60" [disabled]="isDisabled">
    <dx-validator>
      @if (mandatory === true) {
        <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
      }
    </dx-validator>
  </dx-text-area>
</div>
